/**
 * MarketContext — the regional site the app is running as (vowsera.com =
 * global, vowsera.in = india) and its live settings from GET /market:
 * currency, languages, payment gateway, Coming Soon.
 *
 * Until /market answers (or if it can't be reached) the market's built-in
 * defaults apply — see utils/market.js.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '@services/api';
import { MARKET, marketDefaults } from '@utils/market';

const MarketContext = createContext({ market: marketDefaults(MARKET), loaded: true });

export const MarketProvider = ({ children }) => {
  const [state, setState] = useState({ market: marketDefaults(MARKET), loaded: false });

  useEffect(() => {
    let alive = true;
    api.get('/market', { timeout: 8000 })
      .then(r => {
        if (!alive) return;
        const live = r?.data?.data || {};
        setState({ market: { ...marketDefaults(MARKET), ...live, key: MARKET }, loaded: true });
      })
      .catch(() => { if (alive) setState(s => ({ ...s, loaded: true })); });
    return () => { alive = false; };
  }, []);

  return <MarketContext.Provider value={state}>{children}</MarketContext.Provider>;
};

export const useMarket = () => useContext(MarketContext);

export default MarketContext;
